import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';

@Injectable({
  providedIn: 'root',
})
export class WebServiceWorker {
  constructor(private swUpdate: SwUpdate) {
    this.checkForNewVersion();

    this.checkCache();

    // Check for new version every minute
    setInterval(() => this.checkForNewVersion(), 60 * 1000);
  }

  checkForNewVersion = async () => {
    console.log('Service Worker - Checking for new version of the application');
    try {
      // Check if Service Worker is supported by the Browser
      if (this.swUpdate.isEnabled) {
        // Check if new version is available
        const isNewVersion = await this.swUpdate.checkForUpdate();
        if (isNewVersion) {
          console.log('Service Worker - New version of the application is available');
          // Check if new version is activated
          const isNewVersionActivated = await this.swUpdate.activateUpdate();

          // Reload the application with new version if new version is activated
          if (isNewVersionActivated) {
            console.log('Service Worker - New version of the application is activated');
            // if (
            //   confirm(
            //     'Er staat een nieuwe update klaar van Assist, wil je deze toepassen?'
            //   )
            // ) {
            //   window.location.reload();
            // }
          }
        }
      }
    } catch (error) {
      console.log(
        `Service Worker - Error when checking for new version of the application: `,
        error
      );
      window.location.reload();
    }
  };

  checkCache = async () => {
    try {
      // Check if Service Worker is supported by the Browser
      if ('caches' in window) {
        const cacheKeys = await caches.keys();
        let count = 0;
        let smallestCache;

        // Loop through all cached versions
        for (const key of cacheKeys) {
          // Remove cached items based on conditions (in this example, removing index.html from all caches)
          let containsIndexHtml = false;
          const cache = await caches.open(key);
          const cachedRequests = await cache.keys();

          for (const cachedRequest of cachedRequests) {
            if (cachedRequest.url.includes('index.html')) {
              count += 1;
              containsIndexHtml = true;
            }
          }

          if (containsIndexHtml) {
            if (!smallestCache) {
              smallestCache = key;
            } else {
              const cacheSize = cachedRequests.length;
              const smallestCacheSize = (await (await caches.open(smallestCache)).keys()).length;

              if (cacheSize < smallestCacheSize) {
                smallestCache = key;
              }
            }
          }
        }

        // If there are more than 1 cached versions, delete the smallest one with index.html
        if (count > 1 && smallestCache) {
          //delete all caches
          cacheKeys.forEach(async (key) => {
            await caches.delete(key);
          });
        }
      }
    } catch (error) {
      console.error('Error checking and clearing cache:', error);
    }
  };
}
